import { combineReducers } from 'redux'

import isDialogOpen from './isDialogOpen'
import aiModelId from './aiModelId'

export default combineReducers({
  isDialogOpen,
  aiModelId,
})
